
// export const BaseURL = "http://10.202.100.90:8000/api/v1/"; // UAT server
export const BaseURL = "https://builtree.sikasolutions.in/api/v1";  
// export const BaseURL = "https://sika-tree-survey-backend-production.up.railway.app/api/v1";     // UAT server
